import { WIDGET } from '@voltmoney/schema';
import { api } from '../../../configs/api';
import { APP_CONFIG, ConfigTokens, CreditApplicationType, getAppHeader, } from '../../../configs/config';
import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import sharedPropsService from '../../../SharedPropsService';
import { ACTION, } from './types';
import { nextStepId, showLeinRemovalTrackingFlow, truncateToThreeDecimals } from '../../../configs/utils';
let counter = 0;
let hasNavigated = false;
export const enhanceLimit = async (action, _datastore, { instrumentTrack, navigateToBase, network, ...props }) => {
    const user = await SharedPropsService.getUser();
    const borrowerAccountId = user.linkedBorrowerAccounts[0].accountId;
    action.payload.applicationType === CreditApplicationType.CREDIT_MODIFICATION_MARGIN_CALL_AGAINST_SECURITIES ? instrumentTrack("MARGIN_CALL_BUTTON_CLICKED") : instrumentTrack("ENHANCE_LIMIT_BUTTON_CLICKED");
    console.log('applicationType => ', action.payload.applicationType);
    const response = await network.post(`${api.getLimitModificationApplicationForAccount}${borrowerAccountId}`, {
        creditApplicationType: CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES,
    }, {
        headers: await getAppHeader(),
    });
    user.linkedApplications[0] = response.data;
    await SharedPropsService.setUser(user);
    const routeObj = await nextStepId(response.data.currentStepId);
    await SharedPropsService.setConfig(ConfigTokens.IS_PAN_EDIT_ALLOWED, false);
    await SharedPropsService.setConfig(ConfigTokens.IS_RTA_SWITCH_ENABLED, true);
    await SharedPropsService.setConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED, false);
    await navigateToBase(routeObj.routeId, routeObj.params);
};
export const getURL = async (action, _datastore, { setDatastore, network, showPopup, instrumentTrack }) => {
    instrumentTrack('EMAIL_HOLDING_STATEMENT_BUTTON_CLICKED');
    await setDatastore(action.routeId, 'continue', {
        loading: true,
    });
    const user = await sharedPropsService.getUser();
    const accountId = user.linkedBorrowerAccounts[0].accountId;
    const response = await network.get(`${api.pdfHoldingStatement}${accountId}`, {
        headers: await getAppHeader(),
    });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'continue', {
            loading: false,
        });
        showPopup({
            id: 'bt_unpledgeFunds_continue',
            autoTriggerTimerInMilliseconds: APP_CONFIG.MODAL_TRIGGER_TIMEOUT,
            type: 'SUCCESS',
            title: 'Email sent successfully',
            subTitle: 'Account holding details have been sent to your email address.',
            ctaLabel: 'Continue',
            ctaAction: {
                type: ACTION.MENU,
                routeId: ROUTE.UNPLDEGE_FUNDS,
                payload: {},
            },
            primary: false,
        });
    }
    await setDatastore(action.routeId, 'continue', {
        loading: false,
    });
};
export const navigation = async (action, _datastore, { navigate, setDatastore, showPopup, asyncStorage, instrumentTrack }) => {
    if (action.payload.value === 0) {
        await navigate(ROUTE.DASHBOARD);
    }
    if (action.payload.value === 1) {
        await navigate(ROUTE.TRANSACTIONS);
    }
};
export const navigateToDashboard = async (action, _datastore, { navigate, setDatastore, showPopup, asyncStorage, instrumentTrack, removeWidgets }) => {
    hasNavigated = true;
    await removeWidgets(ROUTE.UNPLDEGE_FUNDS, [
        { id: "manageLimit", type: WIDGET.UNPLEDGE_PORTFOLIO }
    ]);
    await navigate(ROUTE.DASHBOARD);
};
export const unPledge = async (action, _datastore, { network, goBack, setDatastore, showPopup }) => {
    const user = await SharedPropsService.getUser();
    // @ts-ignore
    const roundedData = action.payload.pledgedArray.map(item => ({
        ...item,
        tobeUnPledgedUnits: parseFloat(truncateToThreeDecimals(item.tobeUnPledgedUnits)) < item.assetPledgedUnits ? parseFloat(truncateToThreeDecimals(item.tobeUnPledgedUnits)) : item.assetPledgedUnits
    }));
    const response = await network.post(`${api.createRevocation}`, {
        creditId: await user.linkedCredits[0].creditId,
        // @ts-ignore
        securitiesToRevoke: roundedData
    }, {
        headers: await getAppHeader(),
        handleFromMF: true,
    });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'manageLimit', {
            showOtpModalUnpledge: true,
            otpErrorModal: false,
            counter: counter,
        });
        counter++;
    }
    else {
        await setDatastore(action.routeId, 'manageLimit', {
            otpErrorModal: true,
            showOtpModalUnpledge: false,
            otpErrorMessage: response?.response?.data?.message,
            counter: counter,
        });
        counter++;
    }
};
export const verifyOtp = async (action, _datastore, { setDatastore, navigateWithClear, network, goBack }) => {
    const user = await SharedPropsService.getUser();
    const phoneNumber = user.user.phoneNumber;
    const response = await network.post(`${api.verifyOtpRevocation}`, {
        // @ts-ignore
        otp: action.payload.otp,
        // @ts-ignore
        phoneNo: phoneNumber
    }, {
        headers: await getAppHeader(),
        handleFromMF: true
    });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'manageLimit', {
            modalState: "success"
        });
        setTimeout(() => {
            if (!hasNavigated) {
                navigateWithClear(ROUTE.DASHBOARD);
            }
        }, 5000);
    }
    else {
        await setDatastore(action.routeId, 'manageLimit', {
            error: true,
            userName: response.response.data.message
        });
    }
};
export const goBack = async (action, _datastore, { navigateWithClear, goBack, removeWidgets }) => {
    const netPayable = action?.payload?.totalOutstanding;
    const extraOutstandingBufferBajaj = action?.payload?.extraOutstandingBufferBajaj;
    const extraOutstandingBufferDsp = action?.payload?.extraOutstandingBufferDsp;
    await removeWidgets(ROUTE.UNPLDEGE_FUNDS, [
        { id: "manageLimit", type: WIDGET.UNPLEDGE_PORTFOLIO }
    ]);
    if (await showLeinRemovalTrackingFlow()) {
        await navigateWithClear(ROUTE.REMOVE_PLEDGE_STEPS, { netPayable, extraOutstandingBufferBajaj, extraOutstandingBufferDsp });
    }
    else {
        await goBack();
    }
};
export const navigateToFAQ = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.FAQ);
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const navigateToLandingPage = async (action, _datastore, { navigate }) => {
    hasNavigated = true;
    await navigate(ROUTE.DASHBOARD);
};
export const editButtonAction = async (action, _datastore, { instrumentTrack }) => {
    instrumentTrack('EDIT_SELECTED_FUNDS_BUTTON_CLICKED', {
        source_page: 'CONFIRM UNPLEDGE',
    });
};
